import ListWrappers from 'app/modules/wrappers/WrapperList/WrapperList';
import React from 'react';

function HomePage() {
  return <ListWrappers></ListWrappers>;
}

export default HomePage;
